/** Essential roles for logged-in users */
export var UserRole;
(function (UserRole) {
    /** Basic user */
    UserRole[UserRole["User"] = 0] = "User";
    /** System administrator */
    UserRole[UserRole["Admin"] = 1] = "Admin";
})(UserRole || (UserRole = {}));
